module.exports = json2Plugin

function json2Plugin() {
	require('./lib/json2')
	return {}
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/store/plugins/json2.js
 ** module id = 1695
 ** module chunks = 0
 **/